// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/mountain-valley-winds.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/mountain-valley-winds/chinook-and-bora.js';
import g1 from '../lessons/meteorology/mountain-valley-winds/mountain-valley-winds.js';

mount([g0, g1]);
